import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable, shareReplay, map } from "rxjs";
import { DEFAULT_PAGINATE_OPTIONS_LIST, defaultPaginateSelects, PaginateData, PaginateOptions } from '../utils/paginate.utils';

interface QueryParams {
  [key: string]: string;
  field: string,
  value: string
}
interface RawData {
  id: number;
  descripcion: string;
  value: string;
}
interface FormattedData {
  label: string;
  value: number;
}
@Injectable({
  providedIn: 'root'
})

export abstract class ApiService<T> {
  abstract url: string;

  readonly _getContent = new Map<string, Observable<any>>();
  http = inject(HttpClient);
  getApiUrl = () => {
    return environment.backendUrl + this.url;
  }

  // Limpia toda la cache de este servicio
  clearCache() {
    this._getContent.clear();
  }

  //cache key for identify cache file
  getData = (paginateOptions: PaginateOptions = { ...DEFAULT_PAGINATE_OPTIONS_LIST }, ignoreCache:boolean = false): Observable<PaginateData<T>> => {
    const cacheKey = `${JSON.stringify(paginateOptions)}`;
    if (ignoreCache) {
      // Siempre borra el observable anterior si ignoreCache es true
      this._getContent.delete(cacheKey);
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(this.getApiUrl(), {
          params: {
            ...paginateOptions
          }        }).pipe(shareReplay({ bufferSize: 1, refCount: true }))
      );
    }
    return this._getContent.get(cacheKey)!;
  }
  getById = (id: number) => {
    const data = this.http.get(`${this.getApiUrl()}/${id}`)
    return data;
  }
  // getByModalidad = (modalidad_id: number) => {
  //   const data = this.http.get(`${this.getApiUrl()}/${modalidad_id}`)
  //   return data;
  // }
  //TODO: its should be get data paginate and make another request when scroll to bottom
  //TODO: add filter
  getAllForSelect = (params: PaginateOptions = { ...defaultPaginateSelects }, ignoreCache: boolean = false , addField?: string) => {
    // Siempre usar una copia para evitar efectos colaterales
    const safeParams = { ...defaultPaginateSelects, ...params };
    const cacheKey = `select-${JSON.stringify(safeParams)}`;
    if (ignoreCache) {
      this._getContent.delete(cacheKey);
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(
        cacheKey,
        this.http.get<{ data: Array<{ id: number; descripcion: string }> }>(this.getApiUrl(), {
          params: safeParams
        }).pipe(
          map(resp => resp.data.map(item => ({
            value: item.id,
            label: item.descripcion ,
            ...(addField ? { [addField]: item[addField as keyof typeof item] } : {})
          }))), shareReplay({ bufferSize: 1, refCount: true })
        )
      );
    }
    return this._getContent.get(cacheKey)!;
  }
  delete = (id: number, motivo?: string, comment?: string) => {
    return this.http.request('DELETE', `${this.getApiUrl()}/delete/${id}`, {
      body: { motivo, comment }
    });
  }
  restore = (id: number, motivo?: string, comment?: string) => {
    return this.http.request('PATCH', `${this.getApiUrl()}/restore/${id}`, {
      body: { motivo, comment }
    });
  }
  update = (data:any,id: number) =>{
    return this.http.patch(`${this.getApiUrl()}/update/${id}` ,data)
  }
  create = (data: any) => {
    return this.http.post(`${this.getApiUrl()}/create`, data);
  }
}
